import React from 'react';
import { Store } from 'redux';
import { History } from 'history';
import { Provider as ReduxProvider } from 'react-redux';
import { Canvas } from 'react-three-fiber';
import { ConnectedRouter } from 'connected-react-router';
import { Switch, Route } from 'react-router-dom';

import PointRoute from './point-route';
import PlaceRoute from './place-route';
import StoryRoute from './story-route';
import ExperienceRoute from './experience-route';
import LiveTourExperienceRoute from './live-tour-experience-route';
import ActionVideoRoute from './action-video-route';
import TestRoute from './test-route';
import { Cache } from 'three';
// import { isMacLike } from '../../common/device';
import Environment from '../../containers/xr/environment';

Cache.enabled = true;

type XRRootProps = {
  store: Store;
  history: History;
};

const XRRoot = (props: XRRootProps) => {
  return (
    <Canvas colorManagement={false} concurrent pixelRatio={window.devicePixelRatio}>
      <ReduxProvider store={props.store}>
        <ConnectedRouter history={props.history}>
          <Environment>
            <Switch>
              <Route path="/live/embed/:experienceId" exact component={LiveTourExperienceRoute} />
              <Route path="/:city/experience/:experienceId" exact component={ExperienceRoute} />

              <Route path="/:city/point/:pointId" exact component={PointRoute} />
              <Route path="/:city/place/:placeId" exact component={PlaceRoute} />
              <Route path="/:city/place/:placeId/action-video/:type" exact component={ActionVideoRoute} />
              <Route path="/:city/story/:storyId" exact component={StoryRoute} />

              <Route component={TestRoute} />
            </Switch>
          </Environment>
        </ConnectedRouter>
      </ReduxProvider>
    </Canvas>
  );
};

export default XRRoot;
